export default __webpack_public_path__ + "static/media/avatar_42.ce67ac18.png";